/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SavingProductGroupCycleMemberOutputDto { 
    id?: number;
    memberId?: number;
    savingProductId?: number;
    savingProductCycleId?: number;
    memberNumber?: number;
    savingProductCycleMemberStatusId?: number;
    tenantId?: number;
    savingProductCycleMemberStatus?: string | null;
    cycleNumber?: number;
    readonly memberPhone?: string | null;
    memberCountryCode?: string | null;
    memberEmail?: string | null;
    memberFullName?: string | null;
    savingGroupName?: string | null;
    amount?: number;
    periodType?: string | null;
    numberOfContributionPerCycle?: number;
    openForContribution?: boolean;
    startDate?: string;
    userId?: number;
    endDate?: string;
}

